exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mainContent[data-v-158fab61]{padding:0 60px}.topSubMenu[data-v-158fab61]{padding:0 60px;margin:10px 0 5px}.selectedMenu li a[data-v-158fab61]{color:#510087;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-158fab61","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/informes/Listview.vue
// module id = 1007
// module chunks = 2